
const digest = 'bf006e6c49153b87e604c0c4a328eef791668ba90d6250c9c36073c62ef10d9b';
const classes = {"wrapper":"_wrapper_1oxer_1","noThumbnail":"_noThumbnail_1oxer_18","fa":"_fa_1oxer_28","itemControls":"_itemControls_1oxer_32"};
const css = `._wrapper_1oxer_1 {
  display: flex;
  flex-direction: column;
  padding: 24px;
  border: 1px solid #eaedf3;
  flex-grow: 1;
  box-shadow: 0 4px 0 0 rgba(226, 229, 237, 0.3);
  margin-bottom: 16px;
}
._wrapper_1oxer_1 img {
  height: 170px;
  min-width: 170px;
  width: 100%;
  border-radius: 3px;
  object-fit: cover;
  cursor: pointer;
}
._wrapper_1oxer_1 ._noThumbnail_1oxer_18 {
  height: 170px;
  min-width: 170px;
  width: 100%;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
._wrapper_1oxer_1 ._noThumbnail_1oxer_18 ._fa_1oxer_28 {
  font-size: 30px;
  margin-bottom: 30px;
}
._wrapper_1oxer_1 ._itemControls_1oxer_32 {
  display: flex;
  flex-direction: row;
  gap: 30px;
  margin-top: 24px;
  justify-content: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  